import { FC, useEffect, useRef, useState } from 'react';
import { SidebarButton } from '../Layout/SidebarButton';
import { AnchoredModal } from '../Overlay';
import { Text } from '../Typography';
import { cn } from '@/utils/cn';
import { ThemeIcon } from '@/shared/icons';
import { Toggle } from '@/shared/Toggle';
import { useAuth } from '@/hooks/useAuth';
import { logout as authLogout } from '@/services/auth';

export const SettingsMenu: FC = () => {
  const anchorRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  const [enabledDark, setEnabledDark] = useState(false);

  const handleToggle = () => setOpen(v => !v);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    localStorage.setItem('theme', enabledDark ? 'dark' : 'light');
    if (enabledDark) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [enabledDark]);

  return (
    <>
      <div
        ref={anchorRef}
        role="button"
        tabIndex={0}
        onClick={handleToggle}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && handleToggle()}
        className="outline-none border-none w-[50%]"
      >
        <SidebarButton
          header="Hello,"
          title={user?.first_name ?? user?.username ?? user?.email ?? ''}
        />
      </div>

      <AnchoredModal
        open={open}
        anchorRef={anchorRef as React.RefObject<HTMLElement>}
        onClose={handleClose}
        placement="bottom-start"
        offset={16}
        panelClassName="rounded-2xl"
      >
        <div
          className={cn(
            'w-[240px] max-w-[calc(100vw-16px)] bg-white dark:bg-w-[240px] max-w-[calc(100vw-16px)] bg-white dark:bg-grey-black rounded-lg border border-grey-plain dark:border-grey-main overflow-hiddenack rounded-lg overflow-hidden shadow-card'
          )}
        >
          <Text
            variant="text-md-regular"
            className="text-grey-main dark:text-grey-plain px-4 py-[14px]"
          >
            Settings
          </Text>
          <div className="flex items-center gap-3 py-[6px] px-4">
            <ThemeIcon className="text-grey-main dark:text-grey-plain" />
            <div className="flex flex-col w-full">
              <Text variant="text-md-regular" className="text-grey-main dark:text-grey-plain">
                Color theme
              </Text>
              <Text
                variant="text-sm-regular"
                className="text-grey-pseudohover dark:text-grey-medium"
              >
                Light
              </Text>
            </div>
            <Toggle checked={enabledDark} toggle={() => setEnabledDark(e => !e)} />
          </div>
          <div className="p-4 pt-3">
            <button
              className="flex items-center justify-center w-full h-[44px] bg-black text-white rounded-md hover:bg-grey-main"
              onClick={() => authLogout()}
            >
              <Text variant="text-md-regular" className="text-grey-light">
                Log out
              </Text>
            </button>
          </div>
        </div>
      </AnchoredModal>
    </>
  );
};
